/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */

import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Grid from '@mui/material/Grid';
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { map } from 'lodash'
import { useSelector } from 'react-redux';
import { useState } from 'react';

function InformacionGeneral(){
    const { catalogos } = useSelector((state) => state.solicitud);
    const [comoseentero, setcomoseentero] = useState(null);
    const [labelentero, setlabelentero] = useState("Especifique");
    const [textComoseentero, settextComoseentero] = useState("");
    const [textapellidoP, settextapellidoP] = useState("");
    const [textapellidoM, settextapellidoM] = useState("");
    const [textnombre, settextnombre] = useState("");
    const [cmbparentesco, setcmbparentesco] = useState(null);
    const [textparentesco, settextparentesco] = useState("");
    const [textcelular, settextcelular] = useState("");
    const [textotrocelular, settextotrocelular] = useState("");
    const [textmail, settextmail] = useState("");
    const setLabelComoSeEntero = (rowValue) =>{
        if(!rowValue){
            setlabelentero("Especifique");
            return;
        }
           
        if(rowValue.idComoSeEntero === 1)
            setlabelentero("Nombre del doctor");
        if(rowValue.idComoSeEntero === 2)
            setlabelentero("Menciona la red social");
        if(rowValue.idComoSeEntero === 3)
            setlabelentero("Especifique");
        if(rowValue.idComoSeEntero === 4)
            setlabelentero("Especifique");
        if(rowValue.idComoSeEntero === 5)
            setlabelentero("Especifique cual");
    }
    
    return <>
     <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
              <MDBox textAlign="right">
                <MDTypography variant="h6" color="white" style={{opacity: 0.7, fontSize:14}}>
                    ¿Como se enteraron del programa?
                </MDTypography>
              </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={6} lg={6}>
                    <Autocomplete
                            options={catalogos.comoSeEntero}
                            getOptionLabel={(option) => option.descripcion}
                            id="controlled-demo"
                            value={comoseentero}
                            onChange={(event, newValue) => {
                                setcomoseentero(newValue);
                                setLabelComoSeEntero(newValue);
                            }}
                            renderInput={(params) => (
                                <TextField {...params} label={"Seleccione"} variant="outlined" error={false}  />
                            )}
                            style={{width:"100%", marginBottom: "1rem"}}
                            size="small"
                        
                        />
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                    <TextField 
                        value={textComoseentero}
                        onChange={(event)=>{
                            settextComoseentero(event.target.value);
                        }} error={false} helperText=""  
                        label={labelentero}
                        variant="outlined" 
                        style={{width:"100%", marginBottom: "1.5rem"}} size="small" 
                    />
                </Grid>
            </Grid>

          </Grid>
    </Grid>
    <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
              <MDBox textAlign="right">
                <MDTypography variant="h6" color="white" style={{opacity: 0.7, fontSize:14}}>
                     Persona que llena el formato
                </MDTypography>
              </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={2}>
                   <Grid item xs={12} md={4} lg={4}>
                    <TextField 
                            value={textapellidoP}
                            onChange={(event)=>{
                                settextapellidoP(event.target.value);
                            }} error={false} helperText=""  
                            label={"Apellido paterno"}
                            variant="outlined" 
                            style={{width:"100%", marginBottom: "1.5rem"}} size="small" 
                        />
                </Grid>
                <Grid item xs={12} md={4} lg={4}>
                    <TextField 
                        value={textapellidoM}
                        onChange={(event)=>{
                            settextapellidoM(event.target.value);
                        }} error={false} helperText=""  
                        label={"Apellido materno"}
                        variant="outlined" 
                        style={{width:"100%", marginBottom: "1.5rem"}} size="small" 
                    />
                </Grid>
                <Grid item xs={12} md={4} lg={4}>
                    <TextField 
                        value={textnombre}
                        onChange={(event)=>{
                            settextnombre(event.target.value);
                        }} error={false} helperText=""  
                        label={"Nombre"}
                        variant="outlined" 
                        style={{width:"100%", marginBottom: "1.5rem"}} size="small" 
                    />
                </Grid>
            </Grid>

          </Grid>
    </Grid>
   <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
              <MDBox textAlign="right">
                <MDTypography variant="h6" color="white" style={{opacity: 0.7, fontSize:14}}>
                    Parentesco con el niño(a)
                </MDTypography>
              </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={6} lg={6}>
                    <Autocomplete
                            options={catalogos.parentescos}
                            getOptionLabel={(option) => option.descripcion}
                            id="controlled-demo"
                            value={cmbparentesco}
                            onChange={(event, newValue) => {
                                setcmbparentesco(newValue);
                            }}
                            renderInput={(params) => (
                                <TextField {...params} label={"Seleccione"} variant="outlined" error={false}  />
                            )}
                            style={{width:"100%", marginBottom: "1rem"}}
                            size="small"
                        
                        />
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                    <TextField 
                        value={textparentesco}
                        onChange={(event)=>{
                            settextparentesco(event.target.value);
                        }} error={false} helperText=""  
                        label={"Especifique"}
                        variant="outlined" 
                        style={{width:"100%", marginBottom: "1.5rem"}} size="small" 
                    />
                </Grid>
            </Grid>

          </Grid>
    </Grid>
    <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
              <MDBox textAlign="right">
                <MDTypography variant="h6" color="white" style={{opacity: 0.7, fontSize:14}}>
                    Telefono de contacto
                </MDTypography>
              </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={6} lg={6}>
                    <TextField 
                        value={textcelular}
                        onChange={(event)=>{
                            settextcelular(event.target.value);
                        }} error={false} helperText=""  
                        label={"Celular (10 dígitos)"}
                        variant="outlined" 
                        style={{width:"100%", marginBottom: "1.5rem"}} size="small" 
                    />
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                    <TextField 
                        value={textotrocelular}
                        onChange={(event)=>{
                            settextotrocelular(event.target.value);
                        }} error={false} helperText=""  
                        label={"Otro teléfono de contacto (10 dígitos)"}
                        variant="outlined" 
                        style={{width:"100%", marginBottom: "1.5rem"}} size="small" 
                    />
                </Grid>
            </Grid>

          </Grid>
    </Grid>
    <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
              <MDBox textAlign="right">
                <MDTypography variant="h6" color="white" style={{opacity: 0.7, fontSize:14}}>
                    Correo Electrónico
                </MDTypography>
              </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={1}>
                 <Grid item xs={12} md={12} lg={12}>
                    <TextField 
                        value={textmail}
                        onChange={(event)=>{
                            settextmail(event.target.value);
                        }} error={false} helperText=""  
                        label={"Correo"}
                        variant="outlined" 
                        style={{width:"100%", marginBottom: "1.5rem"}} size="small" 
                    />
                </Grid>
            </Grid>

          </Grid>
    </Grid>               
    </>
}

export default InformacionGeneral;